export const initSelect2 = () => {
  // show search bar if there are more than 10 options
  let $fewResults = $("select>option:nth-child(100)").closest(".select2-custom");
  $fewResults.select2({ language: "fr" });
  $('.select2-custom').not($fewResults).select2({ minimumResultsForSearch : -1 });
};
